<template>
  <div>
    <jd-dialog
      title="选择云起人群"
      :visible.sync="dialogVisible"
      width="1200px"
      :before-close="handleClose"
      @close="handleClose"
      @confirm="handleConfirm"
    >
    <jd-form :form-info="formInfo" @search="search" ref="jdForm" :btn30="true"/>
      <div class="new-table-box" style="margin-top: 16px;">
        <jd-table
          ref="tableRef"
          :tableData="tableData"
          :loading="tableLoading"
          :tableInfo="tableInfo"
          :pageInfo="{
            pageSize: pageInfo.size,
            pageNum: pageInfo.current,
            total: total,
          }"
          :selection="true"
          @handlePage="handlePage"
          @handleSelectionChange="selectChange"
          row-key="id"
          :selectable="(row,index)=>{
            return (row.number !== 0 && row.hdStatus == 2) || row.source == 10
          }"
        >
          <template #source="{ row }">
            <div v-if="row.source == 1">手动导入</div>
            <div v-if="row.source == 2">客户标签生成</div>
            <div v-if="row.source == 3">权益发放生成</div>
            <div v-if="row.source == 4">订单生成</div>
            <div v-if="row.source == 5">营销画布生成</div>
            <div v-if="row.source == 6">京东人群转化</div>
            <div v-if="row.source == 7">互动生成</div>
            <div v-if="row.source == 8">数据中心生成</div>
            <div v-if="row.source == 9">京获客生成</div>
            <div v-if="row.source == 10">云起标签生成</div>
          </template>
          <template #status="{ row }">
            <!-- <div v-if="row.status == 2">
              <jd-status :status="2">未生成</jd-status>
            </div> -->
            <div v-if="row.status == 1">
              <jd-status :status="1">生成中</jd-status>
            </div>
            <div v-if="row.status == 2">
              <jd-status :status="0">生成成功</jd-status>
            </div>
            <div v-if="row.status == 3">
              <jd-status :status="3">生成失败
              <el-tooltip :content="row.failReason" placement="right">
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/time_执行结束.png"
                  style="cursor: pointer;width: 14px;position: relative;top: 2px;"
                />
              </el-tooltip></jd-status>
            </div>
          </template>
          <template #hdStatus="{ row }">
            <span class="noClick" v-if="row.status != 2">点击生成互动人群</span>
            <span v-else>
              <!-- <span class="text_btn" @click="hdCrowd(row)" v-if="row.hdStatus == 0 || row.hdStatus == null">点击生成互动人群</span> -->
              <jd-button type="blueText" @click="hdCrowd(row)" v-if="(row.hdStatus == 0 || row.hdStatus == null) && row.source != 10">点击生成互动人群</jd-button>
              <span v-if="row.hdStatus == 1">生成中</span>
              <span v-if="row.hdStatus == 2 || row.source == 10">生成成功</span>
              <span v-if="row.hdStatus == 3">
                <el-tooltip :content="row.hdFailReason" placement="right">
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/u103.png"
                    class="imgs"
                    style="cursor: pointer;width: 14px;position: relative;top: 2px;left: 4px;"
                  />
                </el-tooltip>
                <!-- <span class="text_btn" @click="hdCrowd(row)" v-if="row.hdStatus == 3">重新生成互动人群</span> -->
                 <jd-button type="blueText" @click="hdCrowd(row)" v-if="row.hdStatus == 3">点击生成互动人群</jd-button>
              </span>
            </span>
          </template>
        </jd-table>
      </div>
    </jd-dialog>
  </div>
</template>

<script>
import { getYyunQiCrowd, buildHd } from "@/api/manage/yunQiCrowd.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    peopleList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formInfo:[
        {
          label: "人群信息：",
          prop: "searchKey",
          type: "Input",
          placeholder: "请输入人群名称/描述/ID",
        },
        {
          label: "生成渠道：",
          prop: "source",
          type: "Select",
          value:'',
          options: [
            { label: "全部", value: '' },
            { label: "手动导入", value: '1' },
            { label: "客户标签生成", value: '2' },
            { label: "权益发放生成", value: '3' },
            { label: "订单生成", value: '4' },
            { label: "营销画布生成", value: '5' },
            { label: "京东人群转化", value: '6' },
            { label: "互动生成", value: '7' },
            { label: "数据中心生成", value: '8' },
            { label: "京获客生成", value: '9' },
            { label: "云起标签生成", value: '10' },
          ],
        },
      ],
      form: {
        searchKey: "",
        source: "",
      },
      pageInfo: {
        size: 10,
        current: 1,
      },
      total: 0,
      tableData: [],
      tableInfo:[
        {
          label:'人群名称',
          prop:'name',
        },
        {
          label:'生成渠道',
          prop:'source',
          slot:'source',
        },
        {
          label:'人群数量',
          prop:'number',
          align:'right',
          width:'100'
        },
        {
          label:'人群描述',
          prop:'description',
        },
        {
          label:'创建时间',
          prop:'createTime',
        },
        {
          label:'权益发放人群可用状态',
          prop:'status',
          slot:'status',
          minWidth:'160'
        },
        {
          label:'互动活动人群可用状态',
          prop:'hdStatus',
          slot:'hdStatus',
          minWidth:'160'
        },
      ],
      tableLoading: false,
      selected: [],
      newSelectList: [],
    };
  },
  computed: {
     // 全选
     allSelect: {
      get() {
        const { tableData, newSelectList } = this;
        // 当前页是否全选
        return tableData.every((v) => newSelectList.some((c) => c.id == v.id));
      },
      set(v) {
        // 当前页设置全选
        this.tableData.forEach((c) => this.selectChange(c, v));
      },
    },
  },
  mounted() {
    this.newSelectList = this.peopleList
    this.selected = this.peopleList
    // this.$refs.jdForm.handleSearch();
    this.getTableData()
  },
  methods: {
    // 确定
    handleConfirm(){
      this.$emit("confim",this.newSelectList)
    },
    selectChange(row, check = null) {
      this.newSelectList = row
      return
      if(row.number !== 0 && row.hdStatus == 2){
        const { newSelectList: arr } = this;
        // 是否已选中
        const idx = arr.findIndex((v) => v.id == row.id);
        // 传了选中状态就根据选中状态的来
        if (check !== null)
          check ? !~idx && arr.push(row) : ~idx && arr.splice(idx, 1);
        // 不传就有的就删，没有就加
        else ~idx ? arr.splice(idx, 1) : arr.push(row);
      }
    },
    search(obj){
      for (const key in obj) {
        this.form[key] = obj[key] || "";
      }
      this.pageInfo.current = 1
      this.getTableData()
    },
    // 查询
    handleSearch() {
      this.pageInfo.current = 1
      this.getTableData()
    },
    getTableData(){
      let param = {
        ...this.form,
        ...this.pageInfo,
      };
      this.tableLoading = true;
      getYyunQiCrowd(param)
        .then((res) => {
          if (res.code == 1) {
            this.tableData = res.data.records;
            this.total = res.data.total;
            this.showPeopleCheck()
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleReset() {
      this.form = {
        searchKey: "",
        source: "",
      };
      this.pageInfo.current = 1
      this.getTableData();
    },
    // 生成互动人群
    hdCrowd(row){
      buildHd({id:row.id}).then(res=>{
        if(res.code == 1){
          this.$message.success(res.message)
          this.getTableData();
        }else{
          this.$message.error(res.message)
        }
      })
    },
    // 分页信息变化
    handlePage(val){
       this.pageInfo.current = val.pageNum;
      this.pageInfo.size = val.pageSize;
      this.getTableData();
    },
    // 展示选中项
    showPeopleCheck() {
      this.$nextTick(() => {
        var selected = this.selected;
        this.tableData.forEach((row) => {
          for (var i = 0; i < selected.length; i++) {
            if (row.id == selected[i].id) {
              row.id = row.id + ''// id转为字符串类型
              this.$refs.tableRef.toggleRowSelection(row,true);
              break;
            }
          }
        });
      });
    },
    handleClose() {
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.searchBox {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;

  .search_line {
    display: flex;
    line-height: 32px;
    // margin-right: 50px;
    margin-bottom: 16px;

    > div:nth-of-type(1) {
      width: 70px;
      text-align: right;
    }

    // ::v-deep .el-input input {
    //   background: #f5f5f7;
    //   color: #999999;
    //   border-radius: 2px;
    //   border: 0px;
    // }

    // ::v-deep .el-input input:focus {
    //   background: #ffff;
    //   color: #333333;
    // }
    // ::v-deep .el-input__inner {
    //   border: none;
    // }

    // /* 输入过内容的状态 */
    // ::v-deep .el-input input:not(:placeholder-shown) {
    //   color: #333;
    // }
  }

  .btns {
    flex: 1;
    text-align: right;

    .btn1 {
      background: rgba(39, 104, 255, 0.1);
      color: #2768ff;
      border: none;
    }

    .btn2 {
      background: #f2f3f5;
      color: #666666;
      border: none;
    }
    .btn1:hover {
      color: #5286ff;
    }
    .btn2:hover {
      color: #1f1f1f;
    }
  }
}

.text_btn{
  cursor: pointer !important;
  border-bottom: 1px solid #666666;
  &:hover{
    color: #2768FF;
    border-color: #2768ff;
  }
}
.noClick {
  color: #666666;
  cursor: not-allowed;
}
</style>